var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovoAnalise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 15.625H2.64167C2.19829 15.625 1.9766 15.625 1.80726 15.5387C1.6583 15.4628 1.53719 15.3417 1.46129 15.1927C1.375 15.0234 1.375 14.8017 1.375 14.3583V2.64167C1.375 2.19829 1.375 1.9766 1.46129 1.80726C1.53719 1.6583 1.6583 1.53719 1.80726 1.46129C1.9766 1.375 2.19829 1.375 2.64167 1.375H4.85833C5.30171 1.375 5.5234 1.375 5.69274 1.46129C5.8417 1.53719 5.96281 1.6583 6.03871 1.80726C6.125 1.9766 6.125 2.19829 6.125 2.64167V4.54167M6.125 15.625H10.875M6.125 15.625L6.125 4.54167M6.125 4.54167H9.60833C10.0517 4.54167 10.2734 4.54167 10.4427 4.62795C10.5917 4.70385 10.7128 4.82496 10.7887 4.97392C10.875 5.14327 10.875 5.36496 10.875 5.80833V15.625M10.875 7.70833H14.3583C14.8017 7.70833 15.0234 7.70833 15.1927 7.79462C15.3417 7.87052 15.4628 7.99163 15.5387 8.14059C15.625 8.30994 15.625 8.53163 15.625 8.975V14.3583C15.625 14.8017 15.625 15.0234 15.5387 15.1927C15.4628 15.3417 15.3417 15.4628 15.1927 15.5387C15.0234 15.625 14.8017 15.625 14.3583 15.625H10.875",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovoAnalise);
export default __webpack_public_path__ + "static/media/NovoAnalise.eb7f8133b26e9a843564e491d513c268.svg";
export { ForwardRef as ReactComponent };